/*
 * @Author: qh_feng
 * @Date: 2022-03-16 17:13:02
 * @LastEditors: your name
 * @Description: 
 * @ FilePath: Do not edit
 * @par 修改日志:
 * 内容:
 */
import store from '@/vuex'
const name = {
  sbglqyxxgl: {  //因为里面属性有同名，所以这里用网址路由来自动区分是传哪一页面的属性
    businessLicense: "法人营业执照",
    checkOpinion: "审批意见",
    checkStatus: "审批状态",
    checkTime: "审批时间",
    checker: "审批人",
    coAddress: "企业位置",
    coBusiness: "经营范围",
    coCreateTime: "注册时间",
    coEin: "企业税号",
    coInTime: "入场时间",
    coLicense: "企业执照",
    coName: "企业名称",
    coNature: "企业地址",
    coPerson: "企业法人",
    coType: "企业类型",
    createTime: "创建时间",
    id: "主键编号",
    idcardFan: "法人身份证反面",
    idcardZheng: "法人身份证正面",
    modifyTime: "修改时间",
    personIdcard: "法人身份证号",
    remark: "备注",
    statusName: "企业状态",
    telphone: "联系方式"
  },
  xtglsbgl: {
    deviceName: "设备名称*",
    place: "设备位置*",
    deviceType: "设备类型*",
    tollgateID: "卡口选择",
    longitude: "经度*",
    latitude: "纬度*",
    inOutFlag: "出入口标识",
    status: "设备状态",
    ipAddr: "设备IP*",
    port: "设备端口*",
    deviceID: "设备编号",
    factory: "设备厂商",
    telPerson: "厂商联系人",
    telphone: "厂商联系电话",
    loginName: "设备登录帐号",
    password: "设备登录密码",
    createtor: "创建人",
    modifytor: "修改人",
    productDate: "设备生产日期",
    expireDate: "设备维保到期",
    factoryNo: "厂家设备编号",
    deviceImg: "设备图片",
  },
  xtglkkgl: {
    tid: "卡口编号*",
    name: "卡口名称*",
    type: "卡口类型*",
    place: "卡口位置*",
    status: "卡口状态*",
    img: "卡口图片",
  },
  sbglryxxsb: {
    personIdcard: "身份证号",
    endTime: "通行时间(结束)",
    passType: "通行类型",
    passTime: "通行时间范围",
    personCompany: "申请人企业",
    personFace: "人脸图片",
    personName: "姓名",
    personNo: "主键编号",
    personStatus: "人员状态",
    personType: "人员类型",
    personSex: "性别",
    personAge: "年龄",
    reason: "申报理由",
    source: "申报来源",
    startTime: "通行时间(开始)",
    validityPeriod: "有效期范围",
    validityPeriodEnd: "有效期限(结束)",
    validityPeriodStart: "有效期限(开始)",
    workAddr: "工作地址",
    telphone: "联系电话"

  },
  sbglqyclsb: {
    carCompany: "申请所属公司",
    carFrom: "来访车辆",
    carImage: "车脸图片",
    // carType: "车型类别",  //后端字段改一下这个
    deptmentId: "部门编号",
    plateClass: "车牌种类",
    plateColor: "车牌颜色",
    vehicleColor: "车辆颜色",
    plateNo: "车牌号码",
    vehicleBrand: "车辆品牌",
    vehicleClass: "车辆类型",
    vehicleModel: "子品牌",
    vehicleStyles: "车辆年代款",
  },
  sbglclsbsp: {
    vehicleType: "车型类别",
    deptmentName: "部门名称",
    telphone: "联系电话",
    plateNo: "车牌号码",  //有重复字段，中文不一样的，全部要再声明一次，否则会给后面覆盖匹配不到中文
  },
  sbglrysbsp: {
    reason: "申报理由",
  },
  sbgllsclsb: {
    plateNo: "车牌号码",
  },
  yjbkbkgl: {
    beginTime: "布控时间(开始)",
    endTime: "布控时间(结束)",
    deviceListName: "布控者",
    dispositionType: "布控类型",
    dispositionStatus: "布控状态",
    title: "布控标题",
    reason: "布控理由",
    receiveMobile: "接收布控手机号",
    plateNo: "布控车牌号",
    endHour: "每天失效时间",
    beginHour: "每天生效时间",
    dispositionID: "布控编号",
  },
  xtglaqjyfb: {
    moduleCode: "安全教育分类",
    content: "内容"
  },
  xtglhmdgl: {
    coId: "企业名",
    name: "登记人姓名",
    phone: "登记人手机号",
    reason: "理由",
    plateNo: "车牌号码",
  }
}
let saveNameAll = {}

function computeData(obj, nameChild, element) {
  let list = {}
  let objData = {}
  for (var key in saveNameAll) {
    if (element != saveNameAll[key] && element) continue;
    let type = "text";
    let multipleOpt = [];
    //type有select下拉单选，multiple下拉多选，text输入框， radio单选， checkbox复选， datetime日期+时间， time时间， image图片按钮
    let format = ""
    switch (key) {
      case "idcardFan":
      case "idcardZheng":
      case "businessLicense":
      case "coLicense":
      case "deviceImg":
      case "personFace":
      case "carImage":
      case "img":
        type = "image"
        break;
      case "productDate":
      case "expireDate":
        format = "date"  // datetime类别只需日期不需时间的时候
      case "checkTime":
      case "coCreateTime":
      case "coInTime":
      case "createTime":
      case "modifyTime":
      case "validityPeriod":
      case "beginTime":
        type = "datetime"
        if (nameChild === 'yjbkbkgl') {
          //因为后台弄得同一字段，一个显示时间不要日期，一个显示日期不要时间，特殊处理一下

          type = "datetime";
          format = "date";
        }
        break;
      case "passTime":
      case "startTime":
      case "endTime":
        type = "time"
        if (nameChild === 'yjbkbkgl') {
          //因为后台弄得同一字段，一个显示时间不要日期，一个显示日期不要时间，特殊处理一下

          type = "datetime";
          format = "date";
        }
        break;
      case "tollgateID":
        type = "select"
        if (nameChild !== 'xtglsbgl') break;
        const tid = sessionStorage.getItem('tollgateID')
        let tollgateID = tid ? JSON.parse(tid) : []
        //console.log('卡口数据',tollgateID)
        multipleOpt = tollgateID;
        break;

      default:
        let name = key
        if (key == 'status' && (nameChild === 'xtglsbgl' || nameChild === 'xtglkkgl')) name = "deviceStatus"
        else if (key == 'type' && nameChild === 'xtglkkgl') name = "deviceType"
        else if (key == 'statusName' && nameChild === 'sbglqyxxgl') name = "coStatus"
        // else if (key == 'carType') name = "vehicleType"
        else if (key == 'passType' || key == 'personPassType') name = "personpasstype"
        multipleOpt = store.state.dictionary[name.toUpperCase()] || []

        if (multipleOpt.length) type = "select"
        break;
    }

    if (type == "select") {
      const res = multipleOpt.find((params) => params.code == obj[key]);
      objData[key] = res ? res.name : key === 'checkStatus' ? '未审批' : '';
    } else {
      objData[key] = obj[key]

    }

    if (key == 'vehicleBrand') {
      let options = [
        // {
        // label: '热门城市',
        // options: [
        //   {
        //   value: 'Shanghai',
        //   label: '上海'
        //   }
        // ]
        // }
      ]
      multipleOpt = multipleOpt.reduce((res2, item2) => {
        res2[item2.pinyin] ? res2[item2.pinyin].push(item2) : res2[item2.pinyin] = [item2]
        return res2
      }, {})
      for (let key2 in multipleOpt) {
        options.push({
          label: key2,
          options: multipleOpt[key2]
        })
      }
      multipleOpt = options.sort((a, b) => a.label > b.label ? 1 : -1)
    }
    let listVaule = null;
    if (key == 'validityPeriod') {
      listVaule = `${obj.validityPeriodStart || ''},${obj.validityPeriodEnd || ''}`
    } else {
      listVaule = obj[key]
    }
    list = {
      title: element,
      value: listVaule,
      keyName: key,
      format,
      type: type,
      multipleOpt: multipleOpt   // type:select/multiple时才有下拉选项数据
    }
  }
  return element ? list : objData
}
const sortName2cn = function (obj, sortList) {
  saveNameAll = {}
  const arr = window.location.hash.match(/[a-z]+\-[a-z]+/)
  const nameChild = obj.sortName2cn_nameChild || (arr ? arr[0].replace("-", "") : "")
  for (var key in name) {
    saveNameAll = Object.assign(saveNameAll, name[key])
  }
  saveNameAll = Object.assign({}, obj, saveNameAll, name[nameChild])
  if (sortList) {
    let arr = []
    sortList.forEach(element => {
      arr.push(computeData(obj, nameChild, element))
    })
    return arr
  }
  else {
    return computeData(obj, nameChild)
  }

}
export default sortName2cn




// WEBPACK FOOTER //
// ./src/commons/my-plug/sort-name.js